import { Directive } from "@angular/core";
import { ColumnBase, ColumnInfoService } from "@progress/kendo-angular-grid";

const originalGetter = Object.getOwnPropertyDescriptor(ColumnInfoService.prototype, "leafNamedColumns")?.get;
const collator = new Intl.Collator(undefined, { sensitivity: "base" });

/**
 * Makes a Kendo grid list its columns alphabetically instead of in grid order.
 *
 * Kendo has no public API for this. Surfaces that list columns read
 * `ColumnInfoService.leafNamedColumns` (the chooser ignores any external order),
 * so that getter is the only place the order can be changed. Patching the
 * per-grid service instance reorders every consumer of that list, including:
 * - column chooser (toolbar + column menu)
 * - toolbar / adaptive filter column list
 * - toolbar / adaptive sort column list
 * - toolbar / adaptive group tool column lists
 * - AI assistant column field mapping
 *
 * Does not change the rendered grid column order.
 * Verified against @progress/kendo-angular-grid@20.1.2.
 */
@Directive({
    selector: "kendo-grid[sortColumnChooser]",
    standalone: true,
})
export class SortColumnChooserDirective {
    constructor(columnInfo: ColumnInfoService) {
        if (!originalGetter) {
            return;
        }

        Object.defineProperty(columnInfo, "leafNamedColumns", {
            configurable: true,
            get: () =>
                [...(originalGetter.call(columnInfo) as ColumnBase[])].sort((a, b) =>
                    collator.compare(a.displayTitle, b.displayTitle)
                ),
        });
    }
}
